// extracted by mini-css-extract-plugin
module.exports = {"label":"tagsStep_label__w9rxk","tagButtons":"tagsStep_tagButtons__1Lk45"};